var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainedCaringPharmacist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 52.028 59.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trained_Caring_Pharmacist",
    "data-name": "Trained & Caring Pharmacist",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M239.471,95.493c.462,6.317-1.712,11.308-7.5,14.278-8.486,4.35-19.054-1.847-19.169-11.371a66.971,66.971,0,0,1,1.208-11.546,10.357,10.357,0,0,1,2.07-4,4.69,4.69,0,0,1,4.075-1.965c3.737.054,7.481.124,11.213-.022,2.865-.111,4.64,1.294,5.9,3.6a19.794,19.794,0,0,1,2.093,8.813C239.394,94.019,239.434,94.756,239.471,95.493Zm-2.234.791c.185-3.915-.159-7.623-2.018-11.073a4.073,4.073,0,0,0-3.978-2.267c-3.3.052-6.6.008-9.9.011-2.8,0-4.373,1-5.04,3.752-.643,2.656-.842,5.418-1.322,8.118-.234,1.321.289,1.574,1.485,1.566,6.452-.045,12.9-.02,19.355-.023C236.251,96.366,236.683,96.316,237.237,96.283Zm-22.35,2.44a17.438,17.438,0,0,0,.495,2.565,11.323,11.323,0,0,0,21.748-1.046c.321-1.222.051-1.672-1.3-1.66-6.493.056-12.988.024-19.482.032C215.923,98.615,215.5,98.675,214.886,98.724Z",
    transform: "translate(-200.055 -80.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M253.566,118.759a6.894,6.894,0,0,0-3.829-5.64c-3.326-1.874-6.774-3.541-10.23-5.169-1.594-.75-2.328-.361-3.286,1.166q-3.64,5.808-7.3,11.6c-.28.443-.624.843-1.122,1.509-.031-.048-.061-.093-.093-.141-.031.048-.061.093-.093.141-.5-.665-.842-1.066-1.121-1.509q-3.662-5.795-7.3-11.6c-.957-1.527-1.691-1.916-3.286-1.166-3.456,1.628-6.9,3.3-10.229,5.169a6.893,6.893,0,0,0-3.83,5.64,102.812,102.812,0,0,0,.078,12.544c.239,2.976,1.54,5.247,5.63,5.2,6.718-.069,13.436-.061,20.153-.049,6.718-.011,13.437-.02,20.153.049,4.09.042,5.391-2.228,5.63-5.2A102.819,102.819,0,0,0,253.566,118.759Zm-2.395,12.995c-.168,2.126-1.075,2.638-3.2,2.641q-10.133.012-20.268.006t-20.268-.006c-2.124,0-3.031-.515-3.2-2.641-.329-4.153-.441-8.336-.371-12.5a5.209,5.209,0,0,1,2.818-4.3c2.941-1.667,5.994-3.138,9.009-4.672.974-.5,1.595-.262,2.227.758,2.717,4.379,5.528,8.7,8.36,13.01.531.808.975,1.17,1.424,1.114.449.056.893-.306,1.424-1.114,2.832-4.307,5.643-8.63,8.36-13.01.632-1.02,1.253-1.254,2.227-.758,3.015,1.534,6.068,3,9.009,4.672a5.209,5.209,0,0,1,2.818,4.3C251.612,123.418,251.5,127.6,251.172,131.754Z",
    transform: "translate(-201.691 -76.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(35.58 43.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M232.7,123.5v-2.032h2.863v-2.845H237.6v2.845h2.9V123.5h-2.9v2.879h-2.033V123.5Z",
    transform: "translate(-232.702 -118.622)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainedCaringPharmacist);
export default __webpack_public_path__ + "static/media/Trained & Caring Pharmacist.a2605cce3b943eca9f6d0be7b1a5bba5.svg";
export { ForwardRef as ReactComponent };